// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconRunningArrow, iconRunningArrowTag } from '@ni/nimble-components/dist/esm/icons/running-arrow';
import { wrap } from '../../utilities/react-wrapper';

export type { IconRunningArrow };
export { iconRunningArrowTag };
export const NimbleIconRunningArrow = wrap(IconRunningArrow);